// Detailed CPVC Pro Pipes Catalog Data
export const cpvcProPipesCatalog = {
    page: 1,
    title: "CPVC PRO PIPES",
    hsn_code: "39172390",
    blocks: [
        {
            name: "PIPE SDR-11 (3 METRE LENGTH)",
            items: [
                { size_cm: "1.5", size_inch: "1/2", product_code: "M511110301*", std_pkg_nos: 100, price_inr_per_pc: 312.00 },
                { size_cm: "2.0", size_inch: "3/4", product_code: "M511110302*", std_pkg_nos: 50, price_inr_per_pc: 417.00 },
                { size_cm: "2.5", size_inch: "1", product_code: "M511110303*", std_pkg_nos: 30, price_inr_per_pc: 645.00 },
                { size_cm: "3.2", size_inch: "1¼", product_code: "M511110304", std_pkg_nos: 20, price_inr_per_pc: 1104.00 },
                { size_cm: "4.0", size_inch: "1½", product_code: "M511110305", std_pkg_nos: 15, price_inr_per_pc: 1515.00 },
                { size_cm: "5.0", size_inch: "2", product_code: "M511110306", std_pkg_nos: 8, price_inr_per_pc: 2628.00 }
            ]
        },
        {
            name: "PIPE SDR-11 (5 METRE LENGTH)",
            items: [
                { size_cm: "1.5", size_inch: "1/2", product_code: "M511110501", std_pkg_nos: 60, price_inr_per_pc: 520.00 },
                { size_cm: "2.0", size_inch: "3/4", product_code: "M511110502*", std_pkg_nos: 40, price_inr_per_pc: 695.00 },
                { size_cm: "2.5", size_inch: "1", product_code: "M511110503*", std_pkg_nos: 25, price_inr_per_pc: 1075.00 },
                { size_cm: "3.2", size_inch: "1¼", product_code: "M511110504", std_pkg_nos: 15, price_inr_per_pc: 1840.00 },
                { size_cm: "4.0", size_inch: "1½", product_code: "M511110505", std_pkg_nos: 10, price_inr_per_pc: 2525.00 },
                { size_cm: "5.0", size_inch: "2", product_code: "M511110506", std_pkg_nos: 6, price_inr_per_pc: 4380.00 }
            ]
        },
        {
            name: "PIPE SCHEDULE 80 (3 METRE LENGTH)",
            items: [
                { size_cm: "6.5", size_inch: "2½", product_code: "M511800307", std_pkg_nos: 5, price_inr_per_pc: 6171.00 },
                { size_cm: "8.0", size_inch: "3", product_code: "M511800308", std_pkg_nos: 3, price_inr_per_pc: 8295.00 },
                { size_cm: "10.0", size_inch: "4", product_code: "M511800309", std_pkg_nos: 2, price_inr_per_pc: 12327.00 },
                { size_cm: "15.0", size_inch: "6", product_code: "M511800310", std_pkg_nos: 1, price_inr_per_pc: 25794.00 },
                { size_cm: "20.0", size_inch: "8", product_code: "M511800311", std_pkg_nos: 1, price_inr_per_pc: 40887.00 }
            ]
        },
        {
            name: "PIPE SDR-13.5 (3 METRE LENGTH)",
            items: [
                { size_cm: "1.5", size_inch: "1/2", product_code: "M511130301*", std_pkg_nos: 100, price_inr_per_pc: 273.00 },
                { size_cm: "2.0", size_inch: "3/4", product_code: "M511130302*", std_pkg_nos: 50, price_inr_per_pc: 393.00 },
                { size_cm: "2.5", size_inch: "1", product_code: "M511130303*", std_pkg_nos: 30, price_inr_per_pc: 573.00 },
                { size_cm: "3.2", size_inch: "1¼", product_code: "M511130304", std_pkg_nos: 20, price_inr_per_pc: 942.00 },
                { size_cm: "4.0", size_inch: "1½", product_code: "M511130305*", std_pkg_nos: 15, price_inr_per_pc: 1302.00 },
                { size_cm: "5.0", size_inch: "2", product_code: "M511130306", std_pkg_nos: 8, price_inr_per_pc: 2211.00 }
            ]
        },
        {
            name: "PIPE SDR-13.5 (5 METRE LENGTH)",
            items: [
                { size_cm: "1.5", size_inch: "1/2", product_code: "M511130501", std_pkg_nos: 60, price_inr_per_pc: 455.00 },
                { size_cm: "2.0", size_inch: "3/4", product_code: "M511130502*", std_pkg_nos: 40, price_inr_per_pc: 655.00 },
                { size_cm: "2.5", size_inch: "1", product_code: "M511130503*", std_pkg_nos: 25, price_inr_per_pc: 955.00 },
                { size_cm: "3.2", size_inch: "1¼", product_code: "M511130504*", std_pkg_nos: 15, price_inr_per_pc: 1570.00 },
                { size_cm: "4.0", size_inch: "1½", product_code: "M511130505", std_pkg_nos: 10, price_inr_per_pc: 2170.00 },
                { size_cm: "5.0", size_inch: "2", product_code: "M511130506", std_pkg_nos: 6, price_inr_per_pc: 3685.00 }
            ]
        },
        {
            name: "PIPE SCHEDULE 80 (5 METRE LENGTH)",
            items: [
                { size_cm: "6.5", size_inch: "2½", product_code: "M511800507", std_pkg_nos: 5, price_inr_per_pc: 10285.00 },
                { size_cm: "8.0", size_inch: "3", product_code: "M511800508", std_pkg_nos: 3, price_inr_per_pc: 13825.00 },
                { size_cm: "10.0", size_inch: "4", product_code: "M511800509", std_pkg_nos: 2, price_inr_per_pc: 20545.00 },
                { size_cm: "15.0", size_inch: "6", product_code: "M511800510", std_pkg_nos: 1, price_inr_per_pc: 42990.00 },
                { size_cm: "20.0", size_inch: "8", product_code: "M511800511", std_pkg_nos: 1, price_inr_per_pc: 68145.00 },
                { size_cm: "25.0", size_inch: "10", product_code: "M511800512", std_pkg_nos: 1, price_inr_per_pc: 114440.00 },
                { size_cm: "30.0", size_inch: "12", product_code: "M511800513", std_pkg_nos: 1, price_inr_per_pc: 148865.00 }
            ]
        },
        {
            name: "PIPE SCHEDULE 40 (3 METRE LENGTH)",
            items: [
                { size_cm: "6.5", size_inch: "2½", product_code: "M511400307", std_pkg_nos: 5, price_inr_per_pc: 4515.00 },
                { size_cm: "8.0", size_inch: "3", product_code: "M511400308", std_pkg_nos: 3, price_inr_per_pc: 6105.00 },
                { size_cm: "10.0", size_inch: "4", product_code: "M511400309", std_pkg_nos: 2, price_inr_per_pc: 8859.00 },
                { size_cm: "15.0", size_inch: "6", product_code: "M511400310", std_pkg_nos: 1, price_inr_per_pc: 16749.00 },
                { size_cm: "20.0", size_inch: "8", product_code: "M511400311", std_pkg_nos: 1, price_inr_per_pc: 22230.00 },
                { size_cm: "25.0", size_inch: "10", product_code: "M511400312", std_pkg_nos: 1, price_inr_per_pc: 33639.00 },
                { size_cm: "30.0", size_inch: "12", product_code: "M511400313", std_pkg_nos: 1, price_inr_per_pc: 52101.00 }
            ]
        },
        {
            name: "PIPE SCHEDULE 40 (5 METRE LENGTH)",
            items: [
                { size_cm: "6.5", size_inch: "2½", product_code: "M511400507", std_pkg_nos: 5, price_inr_per_pc: 7525.00 },
                { size_cm: "8.0", size_inch: "3", product_code: "M511400508", std_pkg_nos: 3, price_inr_per_pc: 10175.00 },
                { size_cm: "10.0", size_inch: "4", product_code: "M511400509", std_pkg_nos: 2, price_inr_per_pc: 14765.00 },
                { size_cm: "15.0", size_inch: "6", product_code: "M511400510", std_pkg_nos: 1, price_inr_per_pc: 27915.00 },
                { size_cm: "20.0", size_inch: "8", product_code: "M511400511", std_pkg_nos: 1, price_inr_per_pc: 37050.00 },
                { size_cm: "25.0", size_inch: "10", product_code: "M511400512", std_pkg_nos: 1, price_inr_per_pc: 56065.00 },
                { size_cm: "30.0", size_inch: "12", product_code: "M511400513", std_pkg_nos: 1, price_inr_per_pc: 86835.00 }
            ]
        },
        {
            name: "CPVC PRO PIPE CTS SDR 09 (5 METRE LENGTH)",
            items: [
                { size_cm: "2.0", size_inch: "3/4", product_code: "M511090502", std_pkg_nos: 1, price_inr_per_pc: 895.00 },
                { size_cm: "2.5", size_inch: "1", product_code: "M511090503", std_pkg_nos: 1, price_inr_per_pc: 1490.00 }
            ]
        },
        {
            name: "CPVC PRO PIPE CTS SDR 09 (3 METRE LENGTH)",
            items: [
                { size_cm: "2.0", size_inch: "3/4", product_code: "M511090302", std_pkg_nos: 1, price_inr_per_pc: 537.00 },
                { size_cm: "2.5", size_inch: "1", product_code: "M511090303", std_pkg_nos: 1, price_inr_per_pc: 894.00 }
            ]
        }
    ]
};

// Helper function to format price in INR
export const formatPrice = (price) => {
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(price);
};

// Helper function to get all CPVC products as flat array
export const getAllCPVCProducts = () => {
    const allProducts = [];
    cpvcProPipesCatalog.blocks.forEach((block, blockIndex) => {
        block.items.forEach((item, itemIndex) => {
            allProducts.push({
                id: `cpvc-${blockIndex}-${itemIndex}`,
                category: 'cpvc',
                categoryName: 'CPVC Pipes',
                blockName: block.name,
                name: `CPVC Pro Pipe ${item.size_inch}" (${item.size_cm}cm) - ${block.name}`,
                productCode: item.product_code,
                size: {
                    cm: item.size_cm,
                    inch: item.size_inch
                },
                standardPackaging: item.std_pkg_nos,
                pricePerPiece: item.price_inr_per_pc,
                hsnCode: cpvcProPipesCatalog.hsn_code,
                description: `Premium CPVC Pro Pipe ${item.size_inch}" (${item.size_cm}cm) from Astral. ${block.name}.`,
                specifications: [
                    { label: 'Size', value: `${item.size_inch}" (${item.size_cm}cm)` },
                    { label: 'Product Code', value: item.product_code },
                    { label: 'HSN Code', value: cpvcProPipesCatalog.hsn_code },
                    { label: 'Standard Packaging', value: `${item.std_pkg_nos} pieces` },
                    { label: 'Price per Piece', value: formatPrice(item.price_inr_per_pc) },
                    { label: 'Type', value: block.name }
                ],
                features: [
                    'Temperature resistance up to 93°C',
                    'Corrosion and scale-free',
                    'Lead-free and non-toxic',
                    'ISI certified',
                    'Easy to install',
                    'Long service life'
                ]
            });
        });
    });
    return allProducts;
};
